import {BodyText, Button, ButtonType, Span} from 'modules/ui';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import { getCookie, setCookie } from 'modules/utils';
import { Disclaimer, HeadlineTitle } from 'modules/ui/typography/Typography';
import {
  ButtonsWrapper,
  StyledCookieModal,
  StyledCookieWrapper,
  StyledOverlay,
} from './styled';

export const CookiesModal: React.FC = () => {
  const { t } = useTranslation();

  const [showCookieModal, setShowCookieModal] = React.useState(
    getCookie('acceptCookies'),
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setShowCookieModal(getCookie('acceptCookies'));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleAcceptCookies = (cookieValue: string) => {
    setCookie('acceptCookies', cookieValue, 24 * 30);
  };

  return (
    <>
      {!showCookieModal && (
        <StyledCookieWrapper>
          <StyledOverlay />
          <StyledCookieModal>
            <HeadlineTitle>{t('acceptCookies.settings')}</HeadlineTitle>
            <BodyText>{t('acceptCookies.description')}</BodyText>
            <ButtonsWrapper>
              <Button
                text={t('acceptCookies.accept')}
                onClick={() => handleAcceptCookies('all')}
                ariaLabel={t('acceptCookies.accept')}
              />
              <Button
                type={ButtonType.Secondary}
                text={t('acceptCookies.acceptNecessary')}
                onClick={() => handleAcceptCookies('necessary')}
                ariaLabel={t('acceptCookies.acceptNecessary')}
              />
            </ButtonsWrapper>
            <Button
              type={ButtonType.Text}
              text={t('acceptCookies.more')}
              // eslint-disable-next-line no-return-assign
              onClick={() =>
                (window.location.href =
                  'https://unicreditleasing.hr/home/vise-o-kolacicima')
              }
              ariaLabel={t('acceptCookies.more')}
            />
          </StyledCookieModal>
        </StyledCookieWrapper>
      )}
    </>
  );
};
